<template>
  <div>
    <div class="column-btnDiv">
      <div
        style="font-size:14px;display:inline-block;color: #409eff;cursor: pointer;"
      >
        <span
          title="点赞"
          @click.stop="upvote"
          :class="record.ISUPVOTE ? 'add' : 'del'"
        >
          <i class="icon iconfont icon-zan1"></i>
          点赞({{ record.UPVOTECOUNT }})
        </span>
      </div>
      <el-divider direction="vertical"></el-divider>
      <el-dropdown>
        <span title="分享" style="color: #409EFF;font-size:14px" class="share">
          <i class="el-icon-s-promotion">分享</i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            icon="el-icon-share"
            style="font-size:14px"
            v-clipboard:copy="shareUrl"
            @click.native="shareRecord"
            >复制链接</el-dropdown-item
          >
          <el-dropdown-item>
            <div style="popover-div">
              <span title="二维码" style="display:block">
                <i class="el-icon-picture">二维码扫一扫</i>
              </span>
              <img class="img" :src="qrcode" />
            </div>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-divider direction="vertical"></el-divider>
      <div v-if="!hiddenComment">
        <el-button
          type="text"
          style="font-size:14px"
          @click="commentRecord"
          size="medium"
        >
          <i class="el-icon-view el-icon-s-comment"></i>
          评论({{ record.CriticismCount }})
        </el-button>
        <el-divider direction="vertical"></el-divider>
      </div>

      <el-button
        size="medium"
        style="font-size:14px;margin-left:0"
        type="text"
        icon="el-icon-setting"
        @click="setTag"
        >设置标签</el-button
      >
      <el-divider direction="vertical"></el-divider>
      <div
        style="display: flex;align-items: baseline;"
        v-show="showCompleteInfoBtn"
      >
        <el-button
          type="text"
          @click="addCompleteMemo"
          size="medium"
          icon="el-icon-s-claim"
          >完成总结</el-button
        >
        <el-divider direction="vertical"></el-divider>
      </div>
      <div
        v-show="isMyCreated(record.CREATEUSERID)"
        style="display: flex;align-items: baseline;"
      >
        <div style="display: flex;align-items: baseline;">
          <el-button
            type="text"
            @click="addRecordRelation"
            style="font-size:14px;margin-left:0"
            icon="el-icon-circle-plus-outline"
            size="medium"
            >新增记录关联</el-button
          >
          <el-divider direction="vertical"></el-divider>
          <el-button
            type="text"
            @click="editRecord"
            style="font-size:14px;margin-left:0"
            icon="el-icon-edit"
            size="medium"
            >编辑记录</el-button
          >
          <el-divider direction="vertical"></el-divider>
          <el-button
            type="text"
            @click="delRecord"
            size="medium"
            style="font-size:14px;margin-left:0"
            icon="el-icon-s-claim"
            >删除</el-button
          >
          <el-divider direction="vertical"></el-divider>
        </div>

        <el-button
          size="medium"
          style="font-size:14px;margin-left:0"
          type="text"
          @click="importOther"
          >+ 关联任务</el-button
        >
        <el-divider direction="vertical"></el-divider>
      </div>

      <CreateTaskDropdown
        style="font-size:14px;margin-left:0;display: inline-block;"
        :RelationRecordId="record.ID"
        ref="taskAdd"
        @Success="saveTaskSuccess"
      ></CreateTaskDropdown>
    </div>
    <!-- <comment
      ref="comment"
      v-if="!hiddenComment"
      :MainId="record.ID"
      :Type="'1'"
      :TopNum="'2'"
      :DefaultShowInput="false"
      style="background:#f5f5f5"
      @addCommentSuccess="record.CriticismCount++"
      @delCommentSuccess="record.CriticismCount--"
    ></comment> -->
    <!-- 工作记录编辑 -->
    <SideTagsRecordDialog
      ref="recordDialog"
      @successed="refershRecord"
    ></SideTagsRecordDialog>
    <!-- 工作记录关联 -->
    <div v-if="relationDialogVisible">
      <SideTagsRecordDialog
        ref="recordRelationDialog"
        @successed="getSelectedResult"
      ></SideTagsRecordDialog>
    </div>
    <!-- 添加关联任务 -->
    <taskDialog ref="taskRelationDialog" @getValue="getTask"></taskDialog>
    <!-- 工作记录完成 -->
    <record-complete-info
      :recordId="record.ID"
      ref="completeInfo"
      @successed="refershRecord"
    ></record-complete-info>
    <!-- <div v-if="recordDialogVisible"> -->
    <el-dialog
      title="工作记录评论"
      append-to-body
      :visible.sync="recordDialogVisible"
      width="60%"
    >
      <comment
        :MainId="recordId"
        ref="comment"
        :Type="'1'"
        @addCommentSuccess="refershComment(true)"
        @delCommentSuccess="refershComment(false)"
        @cancelSuccess="cancelSuccess"
      ></comment>
    </el-dialog>
    <!-- </div> -->

    <TagSelect
      ref="tagSelect"
      :tagIds="tagIds"
      :showFootButton="true"
      @success="saveTag"
    ></TagSelect>
  </div>
</template>
// 工作记录按钮
<script>
import TagSelect from "../common/Tag/TagSelect";
import RecordCompleteInfo from "./RecordCompleteInfo.vue";
import CreateTaskDropdown from "@/views/task/common/CreateTaskDropdown";
import taskDialog from "@/components/basicTemplate/common/taskDialog.vue";
import { getQRcode } from "@/api/modules/basicData/commonData.js";
import {
  AddRecordRelation,
  SaveTaskTags,
  AddVote,
  DelRecord,
  UpdateRecordDegree,
  GetRecordRelationByRecordId,
  ChangeRecordState
} from "@/api/modules/basicData/task";
import { getToken } from "@/util/auth";
const cookieUser = getToken();
var person = {
  ID: cookieUser.userId,
  NAME: cookieUser.realName,
  DEPTID: cookieUser.departmentId,
  DEPTNAME: cookieUser.departmentName,
  COMPANYID: cookieUser.organizationId,
  COMPANYNAME: cookieUser.organizationName
};
export default {
  components: {
    CreateTaskDropdown,
    RecordCompleteInfo,
    taskDialog,
    TagSelect,
    comment: () => import("@/components/common/comment.vue")
  },
  props: {
    record: {
      type: Object,
      default: {}
    },
    hiddenComment: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    tagIds() {
      return this.record.Tags != undefined && this.record.Tags != null
        ? this.record.Tags.map(o => o.TAGID)
        : [];
    }
  },
  data() {
    return {
      shareUrl: "",
      qrcode: "",
      rate: 0,
      recordId: "",
      recordCompleted: false,
      recordDialogVisible: false,
      relationDialogVisible: false,
      showCompleteInfoBtn: false
    };
  },
  watch: {
    record(newValue) {
      if (newValue) {
        this.record = newValue;
        if (newValue.CompleteInfo) {
          this.showCompleteInfoBtn =
            newValue.STATE == 2 &&
            !newValue.CompleteInfo.MEMO &&
            newValue.CompleteInfo.CREATEUSERID == cookieUser.userId;
        } else {
          this.showCompleteInfoBtn = false;
        }
        this.recordCompleted = newValue.STATE == 2;
        this.rate = newValue.DEGREE;
        if (!this.qrcode) {
          this.shareUrl = `${location.href.substr(
            0,
            location.href.lastIndexOf("/")
          )}/recordinfo?recordid=${newValue.ID}`;
          getQRcode(this.shareUrl, 150, 150).then(result => {
            console.log(result);
            if (result) this.qrcode = result;
          });
        }
      }
    }
  },
  methods: {
    saveTaskSuccess(task) {
      GetRecordRelationByRecordId(this.record.ID).then(result => {
        if (result) {
          this.record.Relations = result;
        }
      });
    },
    importOther() {
      this.$refs.taskRelationDialog.dialogVisible = true;
    },
    delRecord() {
      this.$confirm("确定删除这条记录吗？", "确认删除", {
        distinguishCancelAndClose: true,
        confirmButtonText: "删除",
        cancelButtonText: "取消"
      }).then(() => {
        DelRecord(this.record.ID).then(result => {
          if (result.ResultCode > 0) {
            this.$message.success("删除成功");
            this.$emit("successed");
          }
        });
      });
    },
    editRecord() {
      this.$refs.recordDialog.editRecord(this.record);
    },
    isMyCreated(userId) {
      if (userId) return userId === cookieUser.userId;
      return false;
    },
    addCompleteMemo() {
      this.$refs.completeInfo.dialogVisible = true;
    },
    saveTag(values) {
      var tags = values.map(value => {
        return {
          TASKID: this.record.ID,
          TAGID: value.ID,
          COLOR: value.COLOR,
          TAGNAME: value.TAGNAME,
          CREATEUSERID: value.CREATEUSERID,
          CREATEUSERNAME: value.CREATEUSERNAME,
          CREATEDEPTID: value.CREATEDEPTID,
          CREATEDEPTNAME: value.CREATEDEPTNAME,
          CREATECOMPANYID: value.CREATECOMPANYID,
          CREATECOMPANYNAME: value.CREATECOMPANYNAME
        };
      });
      SaveTaskTags(tags, this.record.ID).then(result => {
        if (result.ResultCode > 0) {
          this.$emit("successed");
        } else {
          this.$message.error(result.MsgInfo);
        }
      });
    },
    setTag() {
      this.$refs.tagSelect.dialogVisible = true;
    },
    refershComment(isAdd) {
      //
      if (isAdd) this.record.CriticismCount++;
      else this.record.CriticismCount--;
    },
    cancelSuccess() {
      this.recordDialogVisible = false;
    },
    getTask(arr) {
      if (arr && arr.length > 0) {
        console.log(arr);
        let newRelations = arr
          .filter(val => {
            console.log(
              this.record.Relations.map(r => r.RELATIONID).indexOf(val.ID)
            );
            return (
              this.record.Relations.map(r => r.RELATIONID).indexOf(val.ID) ===
              -1
            );
          })
          .map(item => {
            return {
              RELATIONID: item.ID,
              RECORDID: this.record.ID,
              RELATIONTYPE: 0,
              RELATIONINSTANCE: item.INSTANCE,
              RELATIONNAME: item.TASKNAME,
              RELATIONUSERNAME:
                item.EXCUTEUSERNAME == ""
                  ? item.SERVERCENTERNAME
                  : item.EXCUTEUSERNAME
            };
          });
        AddRecordRelation(newRelations).then(result => {
          if (result.ResultCode > 0) {
            this.record.Relations = this.record.Relations.concat(newRelations);
            console.log(this.record.Relations);
          } else {
            this.$message.error(result.MsgInfo);
          }
        });
      }
    },
    addRecordRelation(val) {
      this.relationDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.recordRelationDialog.dialogFormVisible = true;
        this.$refs.recordRelationDialog.type = 0;
      });
    },
    getSelectedResult(item) {
      this.relationDialogVisible = false;
      this.$emit("addRecordRelation", item);
    },
    refershRecord() {
      this.$emit("successed");
    },
    commentRecord() {
      this.recordId = this.record.ID;
      this.recordDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.comment.initialTask();
      });
    },
    shareRecord() {
      this.$message({
        message: "工作记录链接已复制,请粘贴到地址栏访问",
        type: "success"
      });
    },

    upvote() {
      if (this.record.ISUPVOTE) {
        DelVote(this.record.ID, 1, person).then(result => {
          if (result.ResultCode > 0) {
            this.record.ISUPVOTE = false;
            this.record.UPVOTECOUNT--;
          }
        });
      } else {
        AddVote({
          MAINID: this.record.ID,
          MAINTYPE: 1,
          UPVOTEUSERID: person.ID,
          UPVOTEUSERNAME: person.NAME,
          UPVOTEDEPTID: person.DEPTID,
          UPVOTEDEPTNAME: person.DEPTNAME,
          UPVOTECOMPANYID: person.COMPANYID,
          UPVOTECOMPANYNAME: person.COMPANYNAME
        }).then(result => {
          if (result.ResultCode > 0) {
            this.record.ISUPVOTE = true;
            this.record.UPVOTECOUNT++;
          }
        });
      }
    }
  }
};
</script>
<style>
.column-btnDiv /deep/ .el-button + .el-button {
  margin-left: 0 !important;
}
</style>
<style lang="scss" scoped>
.column-btnDiv > .el-dropdown {
  // margin-right: 10px;
  margin-top: 5px;
}

.column-btnDiv {
  display: flex;
  align-items: baseline;
  justify-content: flex-end;
  flex-wrap: wrap;
}
</style>
